export const PaymentMethodType = {
  TokenizedCard: 'TokenizedCard',
  BankAccountDebit: 'BankAccountDebit',
};
